import React, { useState } from 'react';
import { Card, Logo, Flag, EntityLink } from './ui';

export default function LeagueTopScorers({ data }) {
  const [tab, setTab] = useState('scorers');
  const list = tab === 'scorers' ? (data?.topScorers || []) : (data?.topAssists || []);
  return (
    <Card title={tab === 'scorers' ? 'Top scorers' : 'Top assists'}>
      <div className="flex gap-2 mb-4">
        <button className={'i-btn ' + (tab === 'scorers' ? '' : 'i-ghost-btn')} onClick={() => setTab('scorers')}>Scorers</button>
        <button className={'i-btn ' + (tab === 'assists' ? '' : 'i-ghost-btn')} onClick={() => setTab('assists')}>Assists</button>
      </div>
      {(Array.isArray(list) ? list : []).map((s, i) => {
        const p = s?.player || {};
        const nat = p?.nationality || {};
        return (
          <div key={i} className="flex items-center gap-3 py-2 border-b border-shell-border last:border-0">
            <span className="i-dim text-sm w-6">{s?.position ?? i + 1}</span>
            <Logo src={p?.image_path} alt={p?.display_name || p?.name} size={26} fallback={p?.display_name || p?.name} />
            <EntityLink to={(s?.player_id ?? p?.id) ? `/player/${s.player_id ?? p.id}` : null} className="i-fg flex-1 truncate">
              {p?.display_name || p?.name || '—'}
            </EntityLink>
            {nat?.image_path ? (
              <span className="flex items-center gap-1.5"><Flag src={nat.image_path} alt={nat?.name} size={16} /><span className="i-mute text-xs">{nat?.name}</span></span>
            ) : null}
            <span className="i-fg font-semibold">{s?.total ?? '—'}</span>
          </div>
        );
      })}
      {!list.length && <p className="i-dim text-xs">No data.</p>}
    </Card>
  );
}
